'use client';
import React, { FC } from 'react';

export const LogoMark: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_642_7793)">
      <path
        d="M17.9882 12.0714C18.5343 12.0714 18.9951 11.8866 19.3706 11.517C19.7461 11.1474 19.9338 10.6938 19.9338 10.1562C19.9338 9.61857 19.7461 9.16497 19.3706 8.79537C18.9951 8.42577 18.5343 8.24097 17.9882 8.24097C17.4421 8.24097 16.9813 8.42577 16.6058 8.79537C16.2303 9.16497 16.0426 9.61857 16.0426 10.1562C16.0426 10.6938 16.2303 11.1474 16.6058 11.517C16.9813 11.8866 17.4421 12.0714 17.9882 12.0714Z"
        fill="#009FE3"
      />
      <path
        d="M5.84526 12.0714C6.39139 12.0714 6.85219 11.8866 7.22766 11.517C7.60313 11.1474 7.79086 10.6938 7.79086 10.1562C7.79086 9.61857 7.60313 9.16497 7.22766 8.79537C6.85219 8.42577 6.39139 8.24097 5.84526 8.24097C5.29913 8.24097 4.83832 8.42577 4.46286 8.79537C4.08739 9.16497 3.89966 9.61857 3.89966 10.1562C3.89966 10.6938 4.08739 11.1474 4.46286 11.517C4.83832 11.8866 5.29913 12.0714 5.84526 12.0714Z"
        fill="#009640"
      />
      <path
        d="M19.3194 2.43666C18.577 2.11326 17.6085 1.94946 16.4224 1.94946C14.5408 1.94946 13.0645 2.41566 12.0021 3.35226C10.9397 4.28886 10.4064 5.60766 10.4064 7.31286V14.8099V14.9233V15.6079C10.5002 15.6457 10.688 15.7045 10.9696 15.7885C11.2512 15.8725 11.5626 15.9145 11.8997 15.9145C12.4458 15.9145 12.8682 15.7927 13.1712 15.5533C13.4741 15.3139 13.6234 14.9401 13.6234 14.4403V13.9993V13.4491V8.23686C13.6234 5.93946 14.7242 4.78866 16.9301 4.78866C17.5317 4.78866 18.0693 4.85166 18.5386 4.98186C19.008 5.11206 19.4048 5.25066 19.7248 5.39766C19.8357 5.32206 19.985 5.13726 20.1642 4.84326C20.3434 4.54506 20.433 4.24266 20.433 3.92766C20.433 3.25986 20.0618 2.76426 19.3194 2.43666Z"
        fill="#E30613"
      />
      <path
        d="M19.5626 20.0767C18.8714 20.4841 17.4037 21.0931 16.3541 21.4123C14.9504 21.8197 13.6277 21.9919 11.7589 21.9919C9.68105 21.9919 7.96158 21.6727 6.09705 20.9461C3.57971 19.9591 2.95251 19.3753 2.95251 18.1573C2.95251 17.1997 3.50718 16.6453 4.13865 16.6453C4.28371 16.6453 4.55678 16.7335 4.85118 16.8763C7.21918 18.0397 9.26718 18.8713 11.8869 18.8713C14.4896 18.8713 16.4693 18.0691 18.9226 16.8763C19.217 16.7293 19.4901 16.6453 19.6565 16.6453C20.2666 16.6453 20.8426 17.1997 20.8426 18.1573C20.8426 19.0603 20.5482 19.5265 19.5626 20.0767Z"
        fill="#F39200"
      />
    </g>
    <defs>
      <clipPath id="clip0_642_7793">
        <rect
          width="24"
          height="21"
          fill="white"
          transform="translate(0 1.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
